module.exports = __webpack_public_path__ + "static/media/ashish-beergi.ff0555b2.jpg";